// (c) chaehongee. Confidential and proprietary.

import {
    Bookmark,
    Wand,
    SquareUserRound,
    UserRoundPenIcon,
    UserRoundPlus,
    Palette,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type BackstageRoute = 'chat' | 'ai-models' | 'camera-angle' | 'lora' | 'training' | 'saved' | 'preset'

export interface NavigationItem {
    id: string
    label: string
    icon: LucideIcon
    route: BackstageRoute
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
    { id: 'chat', label: 'backstage.directing', icon: Wand, route: 'chat' },
    { id: 'ai-models', label: 'backstage.models', icon: SquareUserRound, route: 'ai-models' },
    { id: 'lora', label: 'backstage.swapFace', icon: UserRoundPenIcon, route: 'lora' },
    { id: 'training', label: 'backstage.newIdentity', icon: UserRoundPlus, route: 'training' },
    { id: 'saved', label: 'backstage.saved', icon: Bookmark, route: 'saved' },
    { id: 'preset', label: 'backstage.preset', icon: Palette, route: 'preset' },
]

